module.exports = __webpack_public_path__ + "images/ecbfc0287993d0b014089cadb88a6cbbPumps.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Pumps.png
// module id = NJcA
// module chunks = 0